var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirsttimerewards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.333 8.66824C1.20685 8.66867 1.08316 8.6333 0.976305 8.56623C0.869453 8.49916 0.783825 8.40314 0.729369 8.28935C0.674913 8.17555 0.653865 8.04863 0.668669 7.92335C0.683473 7.79806 0.733523 7.67955 0.813003 7.58157L7.413 0.781574C7.46251 0.724428 7.52998 0.685811 7.60432 0.672062C7.67867 0.658313 7.75549 0.670248 7.82216 0.705909C7.88883 0.741571 7.94139 0.798838 7.97123 0.868312C8.00106 0.937786 8.00639 1.01534 7.98634 1.08824L6.70634 5.10157C6.66859 5.20259 6.65592 5.31125 6.6694 5.41824C6.68288 5.52524 6.72211 5.62736 6.78373 5.71586C6.84535 5.80436 6.92752 5.87658 7.02319 5.92635C7.11885 5.97611 7.22517 6.00192 7.333 6.00157H11.9997C12.1258 6.00114 12.2495 6.03652 12.3564 6.10359C12.4632 6.17066 12.5488 6.26667 12.6033 6.38047C12.6578 6.49427 12.6788 6.62118 12.664 6.74647C12.6492 6.87175 12.5992 6.99027 12.5197 7.08824L5.91967 13.8882C5.87016 13.9454 5.8027 13.984 5.72835 13.9978C5.654 14.0115 5.57719 13.9996 5.51052 13.9639C5.44385 13.9282 5.39128 13.871 5.36145 13.8015C5.33161 13.732 5.32628 13.6545 5.34634 13.5816L6.62634 9.56824C6.66408 9.46722 6.67676 9.35856 6.66328 9.25157C6.6498 9.14458 6.61056 9.04245 6.54894 8.95396C6.48732 8.86546 6.40515 8.79323 6.30949 8.74347C6.21382 8.6937 6.10751 8.66789 5.99967 8.66824H1.333Z",
    stroke: "url(#paint0_linear_2174_13984)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2174_13984",
    x1: 6.66634,
    y1: 0.666504,
    x2: 6.66634,
    y2: 14.0033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirsttimerewards);
export default __webpack_public_path__ + "static/media/first time rewards.cb12b7253818dc4caac30fe7c1b3cafd.svg";
export { ForwardRef as ReactComponent };